//=============================================================================
//                       <--- Developed By Icon Team ---> 02 february 2021
//=============================================================================

// npm packages
import React, { useState, useEffect, useContext, useCallback } from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import access from "config/access";

// custom pages
import { styles } from "./styles";
import AuditAPI from "apis/audit/audit";
import Context from "context/context";

// material-ui
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import IconButton from "@material-ui/core/IconButton";

// material-ui icons
import ArrowBackIcon from "@material-ui/icons/ArrowBack";

// custom TextField
const CssTextField = withStyles({
  root: {
    "& label.Mui-focused": {
      color: "##D3D3D3",
    },
    "& .MuiFormLabel-root": {
      color: "#707070",
    },
    "& .MuiInputBase-input": {
      color: "#707070",
    },
    "& .MuiInput-underline:before": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#707070",
      },
      "&:hover fieldset": {
        borderColor: "#707070",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#707070",
      },
      "&.MuiOutlinedInput-root": {
        borderRadius: 20,
      },
      "&.MuiOutlinedInput-root": {
        marginTop: 0,
        borderRadius: 20,
      },
    },
  },
})(TextField);

export default function Create(props) {
  const { state, dispatch } = useContext(Context);

  const { getAuditTableConfig, createAuditConfig } = AuditAPI();
  const history = useHistory();
  const classes = styles();

  const [states, setstates] = useState({
    audittableConfig: [],
    tablesArr: [],
    tableName: "",
    columnName: "",
    create: false,
    update: false,
    delete: false,
    reason: false,
    loading: false,
  });

  const {
    audittableConfig,
    tablesArr,
    tableName,
    columnName,
    create,
    update,
    reason,
    loading,
  } = states;

  const setStates = useCallback((newState) => {
    setstates((states) => ({ ...states, ...newState }));
  }, []);

  // For bread-crumbs
  useEffect(() => {
    dispatch({
      type: "SET_PATHNAME",
      payload: ["HOME", "ADMIN", "PROMOTION", "CREATE"],
    });
  }, []);

  useEffect(() => {
    handleGetAuditTableConfig();
  }, []);

  //  api func
  const handleGetAuditTableConfig = async () => {
    try {
      let res = await getAuditTableConfig();
      if (res) {
        const uniqueTablesArr = Array.from(
          new Set(res?.data?.map((a) => a.table_alias_name))
        ).map((name) => {
          return res?.data?.find((a) => a.table_alias_name === name);
        });
        setStates({ audittableConfig: res?.data, tablesArr: uniqueTablesArr });
      }
    } catch (e) {
      console.log({ e });
    }
  };

  // create api func
  const handleCreateRule = async () => {
    try {
      if (!tableName || !columnName) {
        toast.error("Please fill the required fields", {
          toastId: "required-fields-error",
        });
        setStates({ loading: false });
        return;
      }
      let values;
      values = {
        tableName,
        columnName,
        create,
        update,
        delete: states.delete,
        reason,
      };
      let res = await createAuditConfig(values);
      if (res) {
        toast.success("Created", { toastId: "created" });
        history.goBack();
      }
      setStates({ loading: false });
    } catch (e) {
      console.log({ e });
    }
  };

  return (
    <React.Fragment>
      <Grid container spacing={0} style={{ padding: 10 }}>
        <Grid item xs={12}>
          <IconButton
            onClick={() => {
              history.goBack();
            }}
          >
            <ArrowBackIcon style={{ color: "#305698" }} />
          </IconButton>
          <span style={{ fontSize: 18, fontWeight: "bold" }}>Create</span>
        </Grid>
      </Grid>
      <Grid container spacing={2} style={{ padding: 10 }}>
        <Grid item xs={3}>
          <CssTextField
            id={"Type"}
            label={"Table Name"}
            select
            fullWidth
            type={"text"}
            required
            value={tableName}
            onChange={(e) => {
              setStates({ tableName: e.target.value });
            }}
          >
            {tablesArr?.map((t, i) => (
              <MenuItem value={t.table_alias_name} key={i}>
                {t.table_alias_name}
              </MenuItem>
            ))}
          </CssTextField>
        </Grid>
        <Grid item xs={3}>
          <CssTextField
            disabled={!tableName}
            id={"Column Name"}
            label={"Column Name"}
            select
            fullWidth
            type={"text"}
            required
            value={columnName}
            onChange={(e) => {
              setStates({ columnName: e.target.value });
            }}
          >
            {audittableConfig
              ?.filter((a) => a.table_alias_name === tableName)
              ?.map((t, i) => (
                <MenuItem value={t.column_alias_name} key={i}>
                  {t.column_alias_name}
                </MenuItem>
              ))}
          </CssTextField>
        </Grid>
        <Grid item xs={3}>
          <CssTextField
            id={"Create"}
            label={"Create"}
            select
            fullWidth
            type={"text"}
            required
            value={create}
            onChange={(e) => {
              setStates({ create: e.target.value });
            }}
          >
            {[
              { label: "True", value: true },
              { label: "False", value: false },
            ].map((t, i) => (
              <MenuItem value={t.value} key={i}>
                {t.label}
              </MenuItem>
            ))}
          </CssTextField>
        </Grid>
        <Grid item xs={3}>
          <CssTextField
            id={"Update"}
            label={"Update"}
            select
            fullWidth
            type={"text"}
            required
            value={update}
            onChange={(e) => {
              setStates({ update: e.target.value });
            }}
          >
            {[
              { label: "True", value: true },
              { label: "False", value: false },
            ].map((t, i) => (
              <MenuItem value={t.value} key={i}>
                {t.label}
              </MenuItem>
            ))}
          </CssTextField>
        </Grid>
        <Grid item xs={3}>
          <CssTextField
            id={"Delete"}
            label={"Delete"}
            select
            fullWidth
            type={"text"}
            required
            value={states.delete}
            onChange={(e) => {
              setStates({ delete: e.target.value });
            }}
          >
            {[
              { label: "True", value: true },
              { label: "False", value: false },
            ].map((t, i) => (
              <MenuItem value={t.value} key={i}>
                {t.label}
              </MenuItem>
            ))}
          </CssTextField>
        </Grid>
        <Grid item xs={3}>
          <CssTextField
            id={"Reason"}
            label={"Reason"}
            select
            fullWidth
            type={"text"}
            required
            value={reason}
            onChange={(e) => {
              setStates({ reason: e.target.value });
            }}
          >
            {[
              { label: "True", value: true },
              { label: "False", value: false },
            ].map((t, i) => (
              <MenuItem value={t.value} key={i}>
                {t.label}
              </MenuItem>
            ))}
          </CssTextField>
        </Grid>
      </Grid>
      <Grid container spacing={0} style={{ padding: 10 }}>
        <Grid item xs={12} style={{ textAlign: "right" }}>
          <Button
            className={classes.submitBtn}
          onClick={()=> {
              if(state?.userInfo?.editAction){
                setStates({ loading: true });
                handleCreateRule();
              return;
            }  else{
              toast.error(state.userInfo?.editAccess)
            return;
          }}}
            disabled={loading}
          >
            Submit
          </Button>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}
